/**
 * Prestige system data definitions
 * Headless data - no GUI
 */

import type { PrestigeUpgradeId, Prestige2UpgradeId } from '../state.js';

export interface PrestigeUpgradeDef {
  id: PrestigeUpgradeId;
  nameKey: string;
  descKey: string;
  baseCost: number; // GC cost
  maxLevel: number;
}

export const PRESTIGE_UPGRADES: PrestigeUpgradeDef[] = [
  { id: 'galaxyMultiplier', nameKey: 'pup_galaxy_mult', descKey: 'pup_galaxy_mult_desc', baseCost: 5, maxLevel: 20 },
  { id: 'infiltrationAccel', nameKey: 'pup_infil_accel', descKey: 'pup_infil_accel_desc', baseCost: 3, maxLevel: 10 },
  { id: 'tapEnhance', nameKey: 'pup_tap_enhance', descKey: 'pup_tap_enhance_desc', baseCost: 8, maxLevel: 10 },
  { id: 'offlineExpand', nameKey: 'pup_offline_expand', descKey: 'pup_offline_expand_desc', baseCost: 10, maxLevel: 8 },
  { id: 'offlineEfficiency', nameKey: 'pup_offline_eff', descKey: 'pup_offline_eff_desc', baseCost: 15, maxLevel: 5 },
  { id: 'agentDiscount', nameKey: 'pup_agent_discount', descKey: 'pup_agent_discount_desc', baseCost: 7, maxLevel: 5 },
  { id: 'autoClick', nameKey: 'pup_auto_click', descKey: 'pup_auto_click_desc', baseCost: 15, maxLevel: 5 },
  { id: 'goldenLuck', nameKey: 'pup_golden_luck', descKey: 'pup_golden_luck_desc', baseCost: 8, maxLevel: 10 },
  { id: 'comboKeep', nameKey: 'pup_combo_keep', descKey: 'pup_combo_keep_desc', baseCost: 6, maxLevel: 6 },
  { id: 'quickStart', nameKey: 'pup_quick_start', descKey: 'pup_quick_start_desc', baseCost: 25, maxLevel: 1 },
  { id: 'infiltrationMastery', nameKey: 'pup_infiltration_mastery', descKey: 'pup_infiltration_mastery_desc', baseCost: 10, maxLevel: 10 },
  { id: 'agentNetwork', nameKey: 'pup_agent_network', descKey: 'pup_agent_network_desc', baseCost: 20, maxLevel: 5 },
  { id: 'quickInfiltration', nameKey: 'pup_quick_infiltration', descKey: 'pup_quick_infiltration_desc', baseCost: 25, maxLevel: 3 },
  { id: 'criticalChance', nameKey: 'pup_critical_chance', descKey: 'pup_critical_chance_desc', baseCost: 8, maxLevel: 10 },
  { id: 'criticalDamage', nameKey: 'pup_critical_damage', descKey: 'pup_critical_damage_desc', baseCost: 12, maxLevel: 5 },
];

export function getPrestigeUpgradeCost(def: PrestigeUpgradeDef, currentLevel: number): number {
  return def.baseCost * (currentLevel + 1);
}

export interface Prestige2UpgradeDef {
  id: Prestige2UpgradeId;
  nameKey: string;
  descKey: string;
  cost: number; // Cores cost
  maxLevel: number;
}

export const PRESTIGE2_UPGRADES: Prestige2UpgradeDef[] = [
  { id: 'galaxySpeed', nameKey: 'p2up_galaxy_speed', descKey: 'p2up_galaxy_speed_desc', cost: 3, maxLevel: 5 },
  { id: 'autoPrestige', nameKey: 'p2up_auto_prestige', descKey: 'p2up_auto_prestige_desc', cost: 10, maxLevel: 1 },
  { id: 'permanentAgents', nameKey: 'p2up_permanent', descKey: 'p2up_permanent_desc', cost: 5, maxLevel: 1 },
  { id: 'dimensionAccel', nameKey: 'p2up_dimension_accel', descKey: 'p2up_dimension_accel_desc', cost: 8, maxLevel: 3 },
  { id: 'galaxyMemory', nameKey: 'p2up_galaxy_memory', descKey: 'p2up_galaxy_memory_desc', cost: 15, maxLevel: 1 },
  { id: 'spacetimeWarp', nameKey: 'p2up_spacetime', descKey: 'p2up_spacetime_desc', cost: 20, maxLevel: 1 },
  { id: 'galaxyAutomate', nameKey: 'p2up_automate', descKey: 'p2up_automate_desc', cost: 30, maxLevel: 1 },
];
